import {
  InvestmentTransactionType,
  InvestmentTransactionDetails,
} from "hooks/investments/GetInvestmentTransactionsHook";
import {
  TYPE_LABELS,
  formatDate,
  formatNumber,
  FileCell,
  DotsMenu,
  MobileActions,
} from "./tableUtils";
import { isDesktop } from "utils";

interface TreasuryBondsTableProps {
  transactions: InvestmentTransactionType[];
  details: InvestmentTransactionDetails | null;
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const TreasuryBondsTable = ({
  transactions,
  isOwn = false,
  onEditTx,
}: TreasuryBondsTableProps) => {
  if (!isDesktop()) {
    return (
      <div className="itm-mobile-list">
        {transactions.map((tx) => (
          <div key={tx.uuid} className="itm-mobile-card">
            <table className="side-modal__table">
              <tbody>
                <tr>
                  <td className="side-modal__table-label">Transakcja:</td>
                  <td className="side-modal__table-cell">
                    {TYPE_LABELS[tx.type] ?? tx.type}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Data:</td>
                  <td className="side-modal__table-cell">
                    {formatDate(tx.completedAt ?? tx.createdAt)}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Ilość sztuk:</td>
                  <td className="side-modal__table-cell">
                    {tx.type === "buy" ? "+" : "-"}
                    {tx.quantity ?? "Brak"}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Koszt nabycia:</td>
                  <td className="side-modal__table-cell">
                    {formatNumber(tx.totalValue)} {tx?.currency?.currency}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Cena nabycia:</td>
                  <td className="side-modal__table-cell">
                    {formatNumber(tx.calculatedUnitPrice)}{" "}
                    {tx?.currency?.currency}
                  </td>
                </tr>
              </tbody>
            </table>
            <MobileActions
              tx={tx}
              onEdit={
                onEditTx && (isOwn || tx.type === "sell") ? () => onEditTx(tx) : undefined
              }
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <table className="itm-table">
      <thead>
        <tr>
          <th>Transakcja</th>
          <th>Data</th>
          <th>Ilość sztuk</th>
          <th>Umowa</th>
          <th>Koszt nabycia</th>
          <th>Cena nabycia</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx) => (
          <tr key={tx.uuid}>
            <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
            <td>{formatDate(tx.completedAt ?? tx.createdAt)}</td>
            <td>
              {tx.type === "buy" ? "+" : "-"}
              {tx.quantity ?? "Brak"}
            </td>
            <td>
              <FileCell tx={tx} />
            </td>
            <td>
              {formatNumber(tx.totalValue)} {tx?.currency?.currency}
            </td>
            <td>
              {formatNumber(tx.calculatedUnitPrice)} {tx?.currency?.currency}
            </td>
            <td>
              <DotsMenu
                tx={tx}
                hideDownload
                onEdit={
                  onEditTx && (isOwn || tx.type === "sell") ? () => onEditTx(tx) : undefined
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TreasuryBondsTable;
